"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTEL_METRIC_SCRAPPING_INTERVAL = exports.SERVICE_NAME = exports.OTEL_COLLECTOR_URL = void 0;
const isProcessEnv = typeof process !== 'undefined' && (process === null || process === void 0 ? void 0 : process.env);
exports.OTEL_COLLECTOR_URL = (isProcessEnv && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.OTEL_COLLECTOR_URL)) || 'http://localhost:4318';
exports.SERVICE_NAME = 'cw-custom-metrics';
exports.OTEL_METRIC_SCRAPPING_INTERVAL = Number(isProcessEnv && ((_b = process.env) === null || _b === void 0 ? void 0 : _b.OTEL_METRIC_SCRAPPING_INTERVAL)) || 1000;
//# sourceMappingURL=constants.js.map